import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const user = await login(email, password);
      toast.success(`Olá, ${user.name}!`);
      navigate(user.role === "administrador" ? "/admin" : "/app");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md card-soft p-8">
        <div className="text-center">
          <div className="text-4xl">🌟</div>
          <h1 className="mt-2 text-2xl font-extrabold text-[#243B53]">Bem-vindo de volta</h1>
          <p className="text-sm text-[#243B53]/70">Entre para continuar sua jornada</p>
        </div>
        <form onSubmit={onSubmit} className="mt-6 space-y-4">
          <Field label="E-mail" type="email" value={email} onChange={setEmail} testid="login-email-input" />
          <Field label="Senha" type="password" value={password} onChange={setPassword} testid="login-password-input" />
          {error && <div data-testid="login-error" className="text-sm text-red-600 font-bold">{error}</div>}
          <button data-testid="login-submit-btn" disabled={loading} className="btn-primary w-full">
            {loading ? "Entrando…" : "Entrar"}
          </button>
        </form>
        <div className="mt-4 flex items-center justify-between text-sm">
          <Link data-testid="login-forgot-link" to="/forgot-password" className="text-[#5DADE2] font-bold">Esqueci minha senha</Link>
          <Link data-testid="login-subscription-link" to="/assinatura" className="text-[#243B53] font-bold">Sou assinante — como acessar?</Link>
        </div>
        <p className="mt-3 text-xs text-[#243B53]/60 text-center">
          Ainda não tem acesso? Assine em <Link to="/assinatura" className="text-[#5DADE2] font-bold" data-testid="login-cta-subscription">Assinatura</Link>.
        </p>
      </div>
    </div>
  );
}

export function Field({ label, type = "text", value, onChange, testid, placeholder, as, options, ...rest }) {
  if (as === "select") {
    return (
      <label className="block">
        <span className="text-sm font-bold text-[#243B53]">{label}</span>
        <select data-testid={testid} value={value} onChange={(e) => onChange(e.target.value)} className="mt-1 w-full rounded-2xl border border-[#243B53]/15 bg-white px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#5DADE2]">
          {options.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
      </label>
    );
  }
  if (as === "textarea") {
    return (
      <label className="block">
        <span className="text-sm font-bold text-[#243B53]">{label}</span>
        <textarea data-testid={testid} value={value || ""} onChange={(e) => onChange(e.target.value)} rows={rest.rows || 4}
          placeholder={placeholder}
          className="mt-1 w-full rounded-2xl border border-[#243B53]/15 bg-white px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#5DADE2]" />
      </label>
    );
  }
  return (
    <label className="block">
      <span className="text-sm font-bold text-[#243B53]">{label}</span>
      <input data-testid={testid} type={type} value={value || ""} onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="mt-1 w-full rounded-2xl border border-[#243B53]/15 bg-white px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#5DADE2]" />
    </label>
  );
}
